import { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";

type Environment = {
  name: string;
  pathFragment: string;
  label?: string;
};

export const ENVIRONMENTS: Record<string, Environment> = {
  PROD: {
    name: "prod",
    pathFragment: "prod",
    label: "",
  },
  LOCAL: {
    name: "local",
    pathFragment: "localhost",
    label: "Local",
  },
  SANDBOX: {
    name: "sandbox",
    pathFragment: "sandbox",
    label: "Sandbox",
  },
  DEV: {
    name: "dev",
    pathFragment: "dev",
    label: "Dev",
  },
};

export const getEnvironment = (): Environment | undefined => {
  // TODO: Environment source of truth should be an API rather than path
  return (
    Object.values(ENVIRONMENTS).find(({ pathFragment }) =>
      window.location.hostname.includes(pathFragment)
    ) || ENVIRONMENTS.PROD
  );
};

const EnvironmentBadge = () => {
  const [env, setEnv] = useState<Environment | undefined>(undefined);

  useEffect(() => {
    setEnv(getEnvironment());
  }, [getEnvironment]);

  return env && env.name !== "prod" && <Badge bg="warning">{env.label}</Badge>;
};

export default EnvironmentBadge;
